export default __webpack_public_path__ + "static/media/aiButton.97b482a0.png";